module.exports = __webpack_public_path__ + "static/media/jeffreyLSnyder.9c879fe1.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/jeffreyLSnyder.jpg
// module id = 1677
// module chunks = 1